import { canUseDOM } from "./helpers"

export const LOCAL_DOMAIN = `localhost`
export const STAGING_DOMAIN = `staging.wolfandbadger.com`
export const PRODUCTION_DOMAIN = `www.wolfandbadger.com`

export const CURRENT_REGION = process.env.GATSBY_REGION

export const CURRENT_DOMAIN =
  (canUseDOM && window.location.hostname) || `www.wolfandbadger.com`

export const getCurrentEnv = () => {
  const environments: Record<string, string> = {
    [LOCAL_DOMAIN]: `local`,
    [STAGING_DOMAIN]: `staging`,
    [PRODUCTION_DOMAIN]: `production`
  }
  return (
    (canUseDOM && environments[CURRENT_DOMAIN]) ||
    environments[PRODUCTION_DOMAIN]
  )
}

export const isLocal = () => CURRENT_DOMAIN === LOCAL_DOMAIN

export const isStaging = () => CURRENT_DOMAIN === STAGING_DOMAIN

export const isProduction = () => CURRENT_DOMAIN === PRODUCTION_DOMAIN

export const flags = {
  SOFT_FLASH_MESSAGE_DISMISSAL: true
}
